import { EvaluationSummary } from '../types/stats';
import { AnalyticsSegmentedControl } from '../../weld-analytics/components/shared/AnalyticsSegmentedControl';

interface EvaluationTabsProps {
  evaluations: EvaluationSummary[];
  selected: string | null;
  onSelect: (value: string) => void;
}

export const EvaluationTabs = ({ evaluations, selected, onSelect }: EvaluationTabsProps) => {
  if (evaluations.length === 0) {
    return null;
  }

  return (
    <AnalyticsSegmentedControl
      ariaLabel="Evaluation"
      tabs={evaluations.map((evaluation) => ({
        id: evaluation.evaluation,
        label: evaluation.evaluation,
      }))}
      activeId={selected ?? undefined}
      onChange={onSelect}
    />
  );
};
